import { Label, NumberInput, PhoneInput, TextInput } from 'components/Form'
import notification from 'helpers/notification'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import services from 'services/index'
import { defaultData } from '../constants'

const CreateForm = () => {
	const navigate = useNavigate()
	const [disabled, setDisabled] = useState(false)
	const [createData, setCreateData] = useState(defaultData)
	const {
		phone_number,
		phone_number2,
		student_class,
		password,
		username,
		first_name,
		last_name,
	} = createData

	const createStudent = () => {
		const options = {
			method: 'POST',
			data: createData,
			onStart: () => setDisabled(true),
			onError: error => notification('Error', { type: 'error' }),
			onEnd: () => setDisabled(false),
			onSuccess: response => {
				if (response?.status === 201) {
					setCreateData(defaultData)
					navigate('/account/students')
					notification("O'quvchi muvaffaqiyatli yaratildi!", {
						type: 'success',
					})
				} else {
					notification('Error', { type: 'error' })
				}
			},
		}
		services.students.createStudents(options)
	}
	return (
		<div className='pt-6'>
			<div className='grid grid-cols-12 gap-4 mb-6'>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Ism</Label>
					<TextInput
						size='small'
						value={first_name}
						onChange={first_name =>
							setCreateData({ ...createData, first_name })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Familiya</Label>
					<TextInput
						size='small'
						value={last_name}
						onChange={last_name => setCreateData({ ...createData, last_name })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Sinf</Label>
					<NumberInput
						size='small'
						value={student_class}
						onChange={student_class =>
							setCreateData({ ...createData, student_class })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-3'>
					<Label>Otasining telefon raqami</Label>
					<PhoneInput
						size='small'
						value={phone_number}
						onChange={phone_number =>
							setCreateData({ ...createData, phone_number })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-3'>
					<Label>Onasining telefon raqami</Label>
					<PhoneInput
						size='small'
						value={phone_number2}
						onChange={phone_number2 =>
							setCreateData({ ...createData, phone_number2 })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-3'>
					<Label>Login</Label>
					<TextInput
						size='small'
						value={username}
						onChange={username => setCreateData({ ...createData, username })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-3'>
					<Label>Parol</Label>
					<TextInput
						size='small'
						value={password}
						onChange={password => setCreateData({ ...createData, password })}
					/>
				</div>
			</div>
			<div className='flex justify-center sm:justify-end mt-4'>
				<button
					disabled={disabled}
					className='success-btn w-full sm:w-auto'
					onClick={createStudent}
				>
					O'quvchi yaratish
				</button>
			</div>
		</div>
	)
}

export default CreateForm
